<template>
  <div>
    <div class="table-ge mb-2">
      <div class="label-tabs" v-for="(item, i) in info" :key="i">
        <span class="material-icons" style="font-size: 16px; font-weight: 100">
          {{ item.icon }}
        </span>
        {{ item.text }} {{ item.value }}
      </div>
    </div>
    <div>
      <div
        style="
          background: #5dbb66;
          border-radius: 1em 1em 0 0;
          padding: 1em 2em;
          color: #fff;
        "
      >
        Comment
      </div>
      <div style="padding: 0em 2em">
        <b-table
          :fields="fields"
          :items="items"
          :per-page="perPage"
          :current-page="currentPage"
          responsive="sm"
        >
          <template #cell(id)="data">
            <div style="min-width: 100px">
              {{ data.value }}
            </div>
          </template>

          <template #cell(title)="data">
            <div style="min-width: 100px">
              {{ data.value }}
            </div>
          </template>
        </b-table>

        <div
          style="
            display: flex;
            justify-content: flex-end;
            align-items: center;
            gap: 1em;
          "
        >
          <div>
            <b-form-select
              id="per-page-select"
              v-model="perPage"
              :options="pageOptions"
              size="sm"
            ></b-form-select>
          </div>
          <div>
            <b-pagination
              v-model="currentPage"
              :total-rows="rows"
              :per-page="perPage"
              aria-controls="my-table"
              class="pagination-table my-0"
              page-class="active-a"
            ></b-pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      perPage: 5,
      currentPage: 1,
      pageOptions: [
        { value: 1, text: "1 Item" },
        { value: 3, text: "3 Item" },
        { value: 5, text: "5 Item" },
      ],
      fields: [
        { key: "id", label: "No." },
        { key: "title", label: "Title" },
        { key: "des", label: "Description" },
      ],
      items: [
        {
          id: 1,
          title: "title 1",
          des: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not by PM",
        },
        {
          id: 2,
          title: "title 2",
          des: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not by PM",
        },
        {
          id: 3,
          title: "title 3",
          des: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not by PM",
        },
        {
          id: 4,
          title: "title 4",
          des: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not by PM",
        },
      ],
      info: {
        type: {
          text: "Asset Type",
          icon: "inbox",
          value: "A/B/C",
        },
        user: {
          text: "",
          icon: "account_box",
          value: "Mr.stalfan/Mr.Steave",
        },
        building: {
          text: "",
          icon: "house",
          value: "Building A / Floor 1 / Room 1",
        },
        last_date: {
          text: "Last up date",
          icon: "calendar_month",
          value: "12-06-2022",
        },
        rfid: {
          text: "RFID",
          icon: "router",
          value: "2/2",
        },
        alert: {
          text: "",
          icon: "warning",
          value: "Low Priority",
        },
        total_asset: {
          text: "Total Asset",
          icon: "workspaces",
          value: "23 item",
        },
        limit_asset: {
          text: "Location Asset Limit",
          icon: "shopping_cart",
          value: "100 item",
        },
      },
    };
  },
  computed: {
    rows() {
      return this.items.length;
    },
  },
};
</script>

<style lang="scss" scoped>
.table-ge {
  display: grid;
  grid-template-columns: max-content auto;
  gap: 2em;
  padding: 2em;
}
</style>

<style lang="scss">
.pagination-table {
  li {
    padding: 0 !important;
  }
}
.page-item.active .page-link {
  background-color: #32c040;
  border-color: #32c040;
}
</style>